// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import React, { lazy } from "react";
import { Navigate, Outlet } from "react-router";

// React Router loaders
import { providersLoader } from "../../Loaders/ProviderLoader/providersLoader";
import { localUsers } from "../../Loaders/LocalUsersLoader/LocalUsersLoader";

// Protected Routes to manage user access views
import SuperUserRoutes from "../../ProtectedRoutes/SuperUserRoutes";

import { withSuspense } from "../../../hooks/LazyLoader/withSuspense";

const lazyPage = (path) => lazy(() => import(`../../Pages/${path}`));

// Admin views
const Account = lazyPage("Account");
const Users = lazyPage("Users");
const Companies = lazyPage("Companies");
const Company = lazyPage("Company");
const CompanyMembers = lazyPage("CompanyMembers");
const CompanyMemberById = lazyPage("CompanyMemberById");
const CompanyProviders = lazyPage("CompanyProviders");
const Provider = lazyPage("Provider");
const Studios = lazyPage("Studios");
const Studio = lazyPage("Studio");
const CompanyInvites = lazyPage("CompanyInvites");
const CompanyEquipments = lazyPage("CompanyEquipments");
const CompanyKeywords = lazyPage("CompanyKeywords");
const SuperAdmin = lazyPage("SuperAdmin");

const adminRoutes = [
  { path: "account", element: withSuspense(Account) },
  {
    path: "users",
    loader: localUsers,
    element: withSuspense(Users),
  },
  { path: "companies", element: withSuspense(Companies) },
  {
    path: "company/:companyId",
    element: withSuspense(Company),
    children: [
      { index: true, element: <Navigate to="members" replace /> },
      {
        path: "members",
        element: withSuspense(CompanyMembers),
        children: [
          {
            path: ":companyMemberId",
            element: withSuspense(CompanyMemberById),
          },
          {
            path: "super-admin",
            element: (
              <SuperUserRoutes>
                <Outlet />
              </SuperUserRoutes>
            ),
            children: [
              {
                index: true,
                element: withSuspense(SuperAdmin),
              },
            ],
          },
        ],
      },
      {
        path: "invitations",
        element: withSuspense(CompanyInvites),
      },
      {
        path: "studios",
        element: withSuspense(Studios),
        children: [
          {
            path: ":studioUuid",
            element: withSuspense(Studio),
          },
        ],
      },
      {
        path: "providers",
        loader: providersLoader,
        element: withSuspense(CompanyProviders),
        children: [
          {
            path: ":providerId",
            element: withSuspense(Provider),
          },
        ],
      },
      {
        path: "equipment",
        element: withSuspense(CompanyEquipments),
        // TODO: add children route equipmentId
      },
      { path: "keywords", element: withSuspense(CompanyKeywords) },
    ],
  },
  {
    path: "studios",
    element: withSuspense(Studios),
    children: [
      {
        path: ":studioUuid",
        element: withSuspense(Studio),
      },
    ],
  },
];

export default adminRoutes;
